<template>

    <div class="layout">
        <div class="cabinet-page_bg"></div>

        <Header/>

        <div class="content-404-wrapper">

            <VideoIndex/>

            <div class="content">
                <div class="title">404</div>
                <div class="sub-title">Страница не&nbsp;найдена</div>
                <div class="desc">
                    Перейти на <router-link :to="{name: 'Index'}">главную</router-link>
                </div>
            </div>
        </div>


        <Contacts/>
        <Footer/>
    <AuthorizationWindow/>
    </div>

</template>

<script>
    import Header from '@/components/Header';
    import Footer from '@/components/Footer';
    import Contacts from '@/components/Contacts';
    import AuthorizationWindow from "../components/windows/AuthorizationWindow";
    import VideoIndex from "../components/VideoIndex";


    export default {
        name: 'Error404',

        components: {
            VideoIndex,
            AuthorizationWindow,
            Header, Footer, Contacts
        },

        metaInfo: {
            title: 'Not Found'
        },

        beforeCreate() {
            $('body').attr('class', 'p404-page index-layout');
        }
    }



</script>